<div>
  <div
    class="entry-field"
    [ngClass]="{
      'entry-field--disabled': isDisabled,
      'entry-field--readonly': isReadonly
    }"
  >
    <div class="input-label-container">
      <label
        class="entry-field__label"
        for="{{ componentId }}"
        [class.entry-field--error__label]="isError()"
        [class.entry-field--filled__label]="!isError() && !!query"
      >
        {{ placeholder }}
      </label>
      <input
        type="text"
        id="{{ componentId }}"
        class="entry-field__input"
        [placeholder]="'&nbsp;'"
        [ngClass]="getClasses()"
        [class.entry-field--error__input]="isError()"
        (change)="trigger()"
        (blur)="handleBlur()"
        (focus)="filter()"
        [(ngModel)]="query"
        (keyup)="handleKeyUpInteractions($event.keyCode)"
        (keydown)="handleKeyDownInteractions($event.keyCode)"
        [readonly]="isReadonly"
        [disabled]="isDisabled"
      />
    </div>
  </div>
  <div class="address-suggestions" *ngIf="filteredAddressList.length > 0">
    <ul>
      <li
        class="suggestion__item"
        *ngFor="let item of filteredAddressList; let i = index"
        [class.suggestion__item--selected]="i === selectedIndex"
        (mousedown)="select(item)"
      >
        <div class="address-card" [class.address-card--selected]="i === selectedIndex">
          <span>{{ item.title }}</span>
          <span class="address-card__address">{{ getFormattedAddress(item.address) }}</span>
        </div>
      </li>
    </ul>
  </div>
  <p *ngIf="isError()" class="error-message error-message--entry-field">
    {{ getErrorMessage() }}
  </p>
</div>
